import React, { useState } from 'react';

import { useAuthContext } from '../../../Auth/AuthProvider';
import { Dropdown } from 'react-bootstrap';
import { GetStageSheet_getStageSheet_details as StageSheet } from '../../../../types/schemaTypes';
import { NumericFormat as NumberFormat } from 'react-number-format';
import './StageSheet.scss';

interface WeightDetailsProps {
    stageSheetProppantId: number;
    totalWeight: number;
}

interface StageSheetDetailsProps {
    stageSheetBoxId: number;
    station: number;
    weightRemaining: number;
}

interface StageToEditProps {
    weightDetails: WeightDetailsProps[];
    stageSheetDetails: StageSheetDetailsProps[];
}

interface StageSheetEditModeProps {
    stageSheet: StageSheet;
    stagesToEdit: StageToEditProps;
    setStagesToEdit: React.Dispatch<React.SetStateAction<StageToEditProps>>;
    isRevertStageSheetEnabled: boolean;
}

const StageSheetEditMode = ({
    stageSheet,
    stagesToEdit,
    setStagesToEdit,
    isRevertStageSheetEnabled,
}: StageSheetEditModeProps): React.ReactElement => {
    const [station, setStation] = useState(stageSheet.station ?? '');

    const handleOnChangeInput = (value, stageSheetBoxId) => {
        setStation(value);
        const tempStagesToEdit = stagesToEdit;
        let exists = false;
        tempStagesToEdit.stageSheetDetails.map(stageSheetItem => {
            if (stageSheetItem.stageSheetBoxId === stageSheetBoxId) {
                exists = true;
                stageSheetItem.stageSheetBoxId = stageSheetBoxId;
                stageSheetItem.station = value;
                stageSheetItem.weightRemaining = stageSheet.boxWeightRemaining ?? 0;
            }
        });
        if (!exists) {
            tempStagesToEdit.stageSheetDetails.push({
                stageSheetBoxId: stageSheetBoxId,
                station: value,
                weightRemaining: stageSheet.boxWeightRemaining ?? 0,
            });
        }
        setStagesToEdit(tempStagesToEdit);
    };

    return (
        <>
            {stageSheet.stageSheetBellyDump?.map((load, loadIndex) => (
                <>
                    <tr className="StageSheet-Edit-Item-Container">
                        {loadIndex === 0 && (
                            <>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="link" className="StageSheet-Station">
                                            <span>{station === '0' ? '' : station}</span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                1
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                2
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                3
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                4
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <div className="StageSheet-GreenDot-Container">
                                        {stageSheet.boxDesc}
                                        {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                                    </div>
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <NumberFormat
                                        value={stageSheet.boxWeight || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                    />
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <NumberFormat
                                        value={stageSheet.boxWeightRemaining || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                    />
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.proppant}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.location}</td>
                                <>
                                    {stageSheet.stageSheetBoxId === 0 ? (
                                        <td></td>
                                    ) : (
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length} className="StageSheet-Buttons-td">
                                            {stageSheet.isOOS ? (
                                                <div className="StageSheet-Buttons-Container">
                                                    Out of Service
                                                </div>
                                            ) : (
                                                <div className="StageSheet-Buttons-Container">
                                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">OOS</button>
                                                    {stageSheet.boxWeightRemaining &&
                                                    stageSheet.boxWeight &&
                                                    stageSheet.boxWeightRemaining == 0 &&
                                                    stageSheet.boxWeight > stageSheet.boxWeightRemaining ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                            {stageSheet.boxWeightRemaining &&
                                                            stageSheet.boxWeight &&
                                                            stageSheet.boxWeightRemaining == stageSheet.boxWeight ? (
                                                                <>
                                                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                                        Partial
                                                                    </button>
                                                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                                        Delete
                                                                    </button>
                                                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                                        Empty
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </td>
                                    )}
                                </>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.sandPo}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.lofaOrigin}</td>
                            </>
                                )}
                                <td>{load?.loadId}</td>
                                <td>{load?.sandTicket}</td>
                                <td>
                                    <NumberFormat
                                        value={load?.sandTicketWeight || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                    />
                                </td>
                                <td>
                                    <NumberFormat
                                        value={load?.sandTicketWeightRemaining || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                    />
                                </td>
                                {/* <td className="StageSheet-Buttons-td">
                                            {stageSheet.isOOS ? (
                                                <div className="StageSheet-Buttons-Container">
                                                    Out of Service
                                                    {isRevertStageSheetEnabled && (
                                                        <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                            Edit Delivered Wt
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="StageSheet-Buttons-Container">
                                                    {stageSheet.boxWeightRemaining &&
                                                    stageSheet.boxWeight &&
                                                    stageSheet.boxWeightRemaining == 0 &&
                                                    stageSheet.boxWeight > stageSheet.boxWeightRemaining ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                        {isRevertStageSheetEnabled && (
                                                        <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                            Edit Delivered Wt
                                                        </button>
                                                    )}
                                                        </>
                                                    )}
                                                    
                                                </div>
                                            )}
                                        </td> */}
                    </tr>
                    </>
            ))}
                    {/* {Tab View} */}
                    <div className="StageSheet-Tab-Item-Container StageSheet-Edit-Item-Container-For-Tab">
                        <div className="StageSheet-Tab-Item">
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Station #:</span>
                                <span className="StageSheet-Value">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="link" className="StageSheet-Station">
                                            <span>{station === '0' ? '' : station}</span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                1
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                2
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                3
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                // onSelect={() => {
                                                //     handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                                // }}
                                                onClick={() => {
                                                    handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                                }}
                                            >
                                                4
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </span>
                            </div>
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">PO #:</span>
                                <span className="StageSheet-Value">{stageSheet.sandPo}</span>
                            </div>
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Box Wt:</span>
                                <span className="StageSheet-Value">{stageSheet.boxWeight}</span>
                            </div>
                            {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                <div key={idx} className="StageSheet-KeyValues">
                                    <span className="StageSheet-Key">Ticket {idx + 1} :</span>
                                    <span className="StageSheet-Value">
                                    {load?.sandTicket || 0}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <div className="StageSheet-Tab-Item StageSheet-Tab-Item-Lg">
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Origin:</span>
                                <span className="StageSheet-Value">{stageSheet.lofaOrigin}</span>
                            </div>
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Pad Location:</span>
                                <span className="StageSheet-Value">{stageSheet.location}</span>
                            </div>
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Box Wt Remaining:</span>
                                <span className="StageSheet-Value">{stageSheet.boxWeightRemaining}</span>
                            </div>
                            {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                <div key={idx} className="StageSheet-KeyValues">
                                    <span className="StageSheet-Key">St Wt/ St Wt Remaining:</span>
                                    <span className="StageSheet-Value">
                                        <NumberFormat
                                            value={load?.sandTicketWeight || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                        /
                                        <NumberFormat
                                            value={load?.sandTicketWeightRemaining || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </span>
                                </div>
                            ))}
                        </div>

                        <div className="StageSheet-Tab-Item">
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Box:</span>
                                <span className="StageSheet-Value">
                                    <div className="StageSheet-GreenDot-Container">
                                        {stageSheet.boxDesc}
                                        {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                                    </div>
                                </span>
                            </div>
                            <div className="StageSheet-KeyValues">
                                <span className="StageSheet-Key">Type:</span>
                                <span className="StageSheet-Value">{stageSheet.proppant}</span>
                            </div>
                            <br></br>
                            {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                <div key={idx} className="StageSheet-KeyValues">
                                    <span className="StageSheet-Key">Load {idx + 1} #:</span>
                                    <span className="StageSheet-Value">
                                    {load?.loadId || 0}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {stageSheet.isOOS ? (
                            <div className="StageSheet-Tab-Button-Item">
                                Out of Service
                                {/* {isRevertStageSheetEnabled && (
                                    <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled StageSheet-LoadWeight-Buttons-For-Tab">
                                        Edit Delivered Wt
                                    </button>
                                )} */}
                            </div>
                        ) : (
                            <div className="StageSheet-Tab-Button-Item">
                                <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">OOS</button>
                                {stageSheet.boxWeightRemaining &&
                                stageSheet.boxWeight &&
                                stageSheet.boxWeightRemaining == 0 &&
                                stageSheet.boxWeight > stageSheet.boxWeightRemaining ? (
                                    <></>
                                ) : (
                                    <>
                                        {stageSheet.boxWeightRemaining &&
                                        stageSheet.boxWeight &&
                                        stageSheet.boxWeightRemaining == stageSheet.boxWeight ? (
                                            <>
                                                <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                                    Partial
                                                </button>
                                                <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                                    Delete
                                                </button>
                                                <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                                    Empty
                                                </button>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        {/* {isRevertStageSheetEnabled && (
                                            <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled StageSheet-LoadWeight-Buttons-For-Tab">
                                                Edit Delivered Wt
                                            </button>
                                        )} */}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                
        </>
    );
};

export default StageSheetEditMode;
